import { Box } from '@/components/ui/lib/box';
import { Text } from '@/components/ui/lib/text';
import { cn } from '@/utils/cn';
import type { UserAvatarProps } from '@/components/ui/types/user-avatar';

const SIZE_CLASSES: Record<NonNullable<UserAvatarProps['size']>, string> = {
  sm: 'h-7 w-7 text-xs',
  md: 'h-8 w-8 text-sm',
  lg: 'h-10 w-10 text-base',
};

const getInitials = (name: string): string => {
  const parts = name.trim().split(/\s+/);
  return parts
    .slice(0, 2)
    .map((p) => p[0]?.toUpperCase() ?? '')
    .join('');
};

const UserAvatar = ({ displayName, size = 'md', className }: UserAvatarProps) => (
  <Box
    display="inline-flex"
    alignItems="center"
    justifyContent="center"
    rounded="full"
    flexShrink={0}
    className={cn('bg-accent text-white font-semibold select-none', SIZE_CLASSES[size], className)}
    aria-label={displayName}
  >
    <Text fontSize="inherit" fontWeight="inherit" color="inherit" lineHeight="1">
      {getInitials(displayName)}
    </Text>
  </Box>
);

export default UserAvatar;
